import {Box, Button, Container, Dialog, DialogContent, Typography} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BlockIcon from '@mui/icons-material/Block';
import canvasBG from '../assets/canvasBG.png';
import {CallBackIcon} from "../icons";

export default function AbnormalPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get('type');

    const renderContent = () => {
        switch (type) {
            case '1':
                return {title: t('error_occurred'), des: t('try_again_later')};
            case '2':
                return {title: t('no_access_board'), des: t('contact_board_owner')};
            default:
                return {title: t('error_occurred'), des: t('try_again_later')};
        }
    };

    const content = renderContent();

    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundImage: `url(${canvasBG})`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >

            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: 'none',
                        borderRadius: "10px"
                    },
                    '& .MuiDialogContent-root': {
                        padding: '0',
                    }
                }}
            >
                <DialogContent>
                    <Container maxWidth="sm">
                        <div style={{width: 476, height: 160, display: 'flex', flexDirection: "column", justifyContent: "space-evenly"}}>
                            <div style={{fontSize: 18, color: 'var(--c-text-primary)', fontWeight: 500}}>{content.title}</div>
                            <div style={{fontSize: 14, color: 'var(--c-text-primary)'}}>{content.des}</div>
                            <div onClick={() => { navigate('/dashboard'); }} style={{
                                width: 113,
                                height: 32,
                                border: "1px solid var(--c-brand)",
                                color: "var(--c-brand)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontWeight: 500,
                                cursor: 'pointer',
                                marginLeft: 'auto',
                                borderRadius: 20
                            }}><CallBackIcon />&nbsp;{t('return_to_homepage')}</div>
                        </div>
                    </Container>
                </DialogContent>
            </Dialog>
        </Box>
    );
}
